// extracted by mini-css-extract-plugin
export var hideEditor = "_lh-2";
export var infoIcon = "_lh-3";
export var label = "_lh-1";
export var labelContainer = "_lh-0";
export var readonlyText = "_lh-4";